import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateFeaturedEventMutationVariables = Types.Exact<{
  featuredEventId: Types.Scalars['Int']['input'];
  market: Types.Scalars['String']['input'];
  imageFileName: Types.Scalars['String']['input'];
  navigationUrl: Types.Scalars['String']['input'];
  startDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type UpdateFeaturedEventMutation = { __typename?: 'Mutation', wf_trialModeLeads: { __typename?: 'WF_TrialModeLeads_Mutation_Payload', count: number } };


export const UpdateFeaturedEventDocument = gql`
    mutation UpdateFeaturedEvent($featuredEventId: Int!, $market: String!, $imageFileName: String!, $navigationUrl: String!, $startDate: DateTime, $endDate: DateTime) {
  wf_trialModeLeads(
    update: {featuredEvent: {featuredEventId: $featuredEventId, market: $market, imageFileName: $imageFileName, navigationUrl: $navigationUrl, startDate: $startDate, endDate: $endDate}}
  ) {
    count
  }
}
    `;
export type UpdateFeaturedEventMutationFn = Apollo.MutationFunction<UpdateFeaturedEventMutation, UpdateFeaturedEventMutationVariables>;

/**
 * __useUpdateFeaturedEventMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedEventMutation, { data, loading, error }] = useUpdateFeaturedEventMutation({
 *   variables: {
 *      featuredEventId: // value for 'featuredEventId'
 *      market: // value for 'market'
 *      imageFileName: // value for 'imageFileName'
 *      navigationUrl: // value for 'navigationUrl'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUpdateFeaturedEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedEventMutation, UpdateFeaturedEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedEventMutation, UpdateFeaturedEventMutationVariables>(UpdateFeaturedEventDocument, options);
      }
export type UpdateFeaturedEventMutationHookResult = ReturnType<typeof useUpdateFeaturedEventMutation>;
export type UpdateFeaturedEventMutationResult = Apollo.MutationResult<UpdateFeaturedEventMutation>;
export type UpdateFeaturedEventMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedEventMutation, UpdateFeaturedEventMutationVariables>;